import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryLogo from '@/assets/goldenbet888/images/racing/mysteryBetLogo.png';

export const mysteryBetStyles: MysteryBetSchema = {
  flexWrapperOdds: {
    gap: 1,
  },
  flexWrapperLogoOdds: {
    gap: 3,
  },
  buttonOdds: { variant: 'odds' },
  imageLogo: {
    w: '250px',
    src: mysteryLogo,
  },
  iconMystery: {
    mb: '1',
  },
  textSlash: {
    color: 'whiteAlpha.400',
    fontWeight: 'bold',
  },
  flexWrapperMysteryLabelView: {
    color: 'gamma.200',
    fontFamily: 'accentStaat',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontWeight: 'normal',
    gap: 1,
    lineHeight: 'normal',
    alignItems: 'center',
    sx: {
      '&&': {
        svg: {
          mb: '0.5',
        },
      },
    },
  },
  buttonAddToBetslip: {
    variant: 'solid',
    sx: {
      '&&': {
        borderLeftRadius: 'none',
        boxShadow:
          '0px 6px 10px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 2px rgba(255, 192, 51, 1) inset, 0px 0px 0px 3px rgba(117, 20, 16, 1) inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.6) inset',
        ms: '0',
        fontSize: 'sm',
        fontWeight: 'normal',

        _disabled: {
          opacity: 1,
          bg: 'blackAlpha.500',
          boxShadow:
            '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
          color: 'gamma.500',
        },
      },
    },
  },
  buttonMysteryLabel: {
    variant: 'unstyled',
    color: 'gamma.200',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'base',
    borderRightRadius: 'none',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'sm',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    sx: {
      '&&': {
        px: [2, 3],
        svg: {
          mb: '0.5',
        },
      },
    },
  },
  flexWrapperMysteryRolloverView: {
    w: 'fit-content',
    bg: 'blackAlpha.400',
    borderRadius: 'base',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    px: '3',
    color: 'gamma.200',
    overflow: 'hidden',
    mx: 'auto',
  },
  flexWrapperMysteryPlacedBetView: {
    fontFamily: 'Staatliches',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
    fontSize: 'sm',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: [0, '1.5'],
  },
  flexWrapperMysteryBetSelectionView: {
    alignItems: 'center',
    justifyContent: 'center',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    p: '2',
  },
  flexWrapperMysteryBetReviewView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'column',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    my: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryErrorView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'row',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryTooltipIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'beta.300',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.25) inset, 0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: 'base',
    boxSize: '10',
    p: '2',
    color: 'beta.800',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
    cursor: 'pointer',
  },
  flexWrapperWithTooltip: {
    gap: 2,
  },
  imageMysteryBet: {
    w: '5',
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    mr: '4',
  },
  flexRaceInfo: {
    fontSize: 'sm',
    color: 'gamma.200',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
    whiteSpace: 'nowrap',
  },
  textPriceInfo: {
    fontSize: 'sm',
    color: 'gamma.500',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
  },
  textRollover: {
    fontSize: 'sm',
    color: 'gamma.500',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
  },
  textError: {
    color: 'gamma.500',
    fontFamily: 'accentStaat',
    fontWeight: 'normal',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontStyle: 'normal',
    fontSize: 'xs',
  },
  iconBack: {
    boxSize: '10',
    color: 'gamma.500',
  },
  iconRace: { color: 'beta.300', mb: '2' },
  textSpanWhite: {
    color: 'beta.300',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    whiteSpace: 'nowrap',
    _last: {
      color: 'gamma.200',
    },
  },
  buttonRollOver: {
    variant: 'secondary',
    h: '7',
    fontSize: 'sm',
    fontWeight: 'normal',

    sx: {
      _disabled: {
        pointerEvents: 'none',
        opacity: 1,
        bg: 'blackAlpha.500',
        boxShadow:
          '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
        color: 'gamma.200',
      },
    },
  },
  buttonMyBets: {
    fontSize: 'sm',
    fontWeight: 'normal',
  },
  spanSelectionText: {
    color: 'gamma.500',
  },
  spanPositionType: {
    color: 'beta.300',
  },
};
